import { useTheme } from "@/lib/theme";
import { Logo } from "./Logo";

export function SplashScreen({
  tagline = "learn romanian · word by word",
}: {
  tagline?: string;
} = {}) {
  const { resolved } = useTheme();
  const variant = resolved === "dark" ? "dark" : "color";
  const shadow =
    resolved === "dark"
      ? "drop-shadow(0 8px 24px rgba(123,165,224,0.2))"
      : "drop-shadow(0 8px 24px rgba(59,114,198,0.18))";

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-4 bg-bg">
      <Logo variant={variant} className="size-[88px]" style={{ filter: shadow }} />
      <div
        className="text-[28px] font-bold tracking-[-0.04em] text-text"
        style={{ fontVariantNumeric: "tabular-nums" }}
      >
        rmnlng
      </div>
      <div className="text-[13px] text-text-3">{tagline}</div>
    </div>
  );
}
